export default __webpack_public_path__ + "static/1220-4d6adb1b07d46c0c2c925a8a75f3ab35.gif";